import * as normalize from 'utils/normalize';

import getPatientName from 'utils/print/getPatientName';
import getPatientAddress from 'utils/print/getPatientAddress';
import getPatientCity from 'utils/print/getPatientCity';
import getPatientState from 'utils/print/getPatientState';
import getPatientZip from 'utils/print/getPatientZip';
import getPatientFullDob from 'utils/print/getPatientFullDob';
import getPatientGender from 'utils/print/getPatientGender';
import getPatientFullPhone from 'utils/print/getPatientFullPhone';

import getOrderLineHCPCSCode from 'utils/print/getOrderLineHCPCSCode';
import getOrderLineDescription from 'utils/print/getOrderLineDescription';
import getOrderLineModel from 'utils/print/getOrderLineModel';
import getOrderLineCharge from 'utils/print/getOrderLineCharge';
import getOrderLineUnits from 'utils/print/getOrderLineUnits';
import getOrderLineTotalCharge from 'utils/print/getOrderLineTotalCharge';
import getOrderTotalCharge from 'utils/print/getOrderTotalCharge';
import getSignature from 'utils/print/getSignature';
import getBusinessName from 'utils/print/getBusinessName';
import getFacilityStreet from 'utils/print/getFacilityStreet';
import getFacilityCityStateZip from 'utils/print/getFacilityCityStateZip';
import getBusinessPhone from 'utils/print/getBusinessPhone';
import getBusinessFax from 'utils/print/getBusinessFax';
import getBusinessEmail from 'utils/print/getBusinessEmail';
import getOrderLineDriverFullName from 'utils/print/getOrderLineDriverFullName';

import getAccountName from 'utils/print/getAccountName';
import getDiagnosisCode from 'utils/print/getDiagnosisCode';
import getPrescriberName from 'utils/print/getPrescriberName';
import getPrescriberNPI from 'utils/print/getPrescriberNPI';
import getInsuranceID from 'utils/print/getInsuranceID';
import getBusinessNPI from 'utils/print/getBusinessNPI';
import getInquiringProviderTaxID from 'utils/print/getInquiringProviderTaxID';

const DeliveryTicketDeliveryInstructionsAndReceipt = {
  ID: 32,
  Name: 'Alba Authorization Request',
  Type: 'Prior Authorization Template',
  Format: 'letter',
  Orientation: 'p',
  OrderLineMax: 14,
  WithCharge: true,
  Pages: [
    {
      ID: 1,
      imageUrl: 'assets/documents/Prior-Authorization-Template-Alba-Authorization-Request/1.js',
      Logo: {
        x: 17,
        y: 12,
        width: 50,
        height: 20,
      },
      texts: [
        {
          name: 'Business Name',
          getText: props => getBusinessName(props),
          x: 108,
          y: 5,
          align: 'center',
          fontStyle: 'italic',
          fontSize: 7,
          lineHeight: 1.2,
        },
        {
          name: 'Business Street',
          getText: props => getFacilityStreet(props),
          x: 159,
          y: 15,
          fontWeight: 'bold',
          fontSize: 7,
          lineHeight: 1.2,
        },
        {
          name: 'Business City State Zip',
          getText: props => getFacilityCityStateZip(props),
          x: 159,
          y: 18,
          fontWeight: 'bold',
          fontSize: 7,
          lineHeight: 1.2,
        },
        {
          name: 'Business Phone',
          getText: props => `Tel: ${getBusinessPhone(props)}`,
          x: 159,
          y: 21,
          fontWeight: 'bold',
          fontSize: 7,
          lineHeight: 1.2,
        },
        {
          name: 'Business Fax',
          getText: props => `Fax: ${getBusinessFax(props)}`,
          x: 159,
          y: 24,
          fontWeight: 'bold',
          fontSize: 7,
          lineHeight: 1.2,
        },
      ],
      fields: [
        {
          name: 'Attn',
          type: 'text',
          x: 35,
          y: 77,
          width: 65,
        },
        {
          name: 'From',
          type: 'text',
          x: 115,
          y: 77,
          width: 55,
          getValue: getAccountName,
        },
        {
          name: 'Company',
          type: 'text',
          x: 43,
          y: 86,
          width: 57,
        },
        {
          name: 'Date',
          type: 'text',
          x: 115,
          y: 86,
          width: 55,
          normalize: normalize.date,
        },
        {
          name: 'Fax',
          type: 'text',
          x: 34,
          y: 96,
          width: 66,
          normalize: normalize.phone,
        },
        {
          name: 'Pages',
          type: 'text',
          x: 115,
          y: 96,
          width: 55,
        },
        {
          name: 'Phone',
          type: 'text',
          x: 39,
          y: 105,
          width: 61,
          normalize: normalize.phone,
        },
        {
          name: 'Re',
          type: 'text',
          getValue: getPatientName,
          x: 110,
          y: 105,
          width: 60,
        },
        {
          name: 'Urgent',
          type: 'checkbox',
          x: 25,
          y: 114.5,
          width: 5,
          height: 5,
        },
        {
          name: 'For Review',
          type: 'checkbox',
          x: 55,
          y: 114.5,
          width: 5,
          height: 5,
          getValue: () => true,
        },
        {
          name: 'Please Comment',
          type: 'checkbox',
          x: 92,
          y: 114.5,
          width: 5,
          height: 5,
        },
        {
          name: 'Please Reply',
          type: 'checkbox',
          x: 140,
          y: 114.5,
          width: 5,
          height: 5,
        },
        {
          name: 'Comments',
          type: 'text',
          x: 20,
          y: 135,
          width: 150,
          height: 63,
          multiline: true,
          getValue: (props) => `IF AUTH IS NOT REQUIRED, PLEASE SEND BACK NO AUTH REQUIRED NOTES/LETTER.
YOU CAN FAXBACK TO ${getBusinessFax(props)}.
YOU CAN ALSO SEND IT THRU EMAIL AT ${getBusinessEmail(props) || 'SALES@ALBASUPPLIES.COM'}.
THANK YOU,`
        },
      ],
    },
    {
      ID: 2,
      imageUrl: 'assets/documents/Prior-Authorization-Template-Alba-Authorization-Request/2.js',
      Logo: {
        x: 17,
        y: 12,
        width: 50,
        height: 20,
      },
      texts: [
        {
          name: 'Business Name',
          getText: props => getBusinessName(props),
          x: 108,
          y: 5,
          align: 'center',
          fontStyle: 'italic',
          fontSize: 7,
          lineHeight: 1.2,
        },
        {
          name: 'Business Street',
          getText: props => getFacilityStreet(props),
          x: 159,
          y: 15,
          fontWeight: 'bold',
          fontSize: 7,
          lineHeight: 1.2,
        },
        {
          name: 'Business City State Zip',
          getText: props => getFacilityCityStateZip(props),
          x: 159,
          y: 18,
          fontWeight: 'bold',
          fontSize: 7,
          lineHeight: 1.2,
        },
        {
          name: 'Business Phone',
          getText: props => `Tel: ${getBusinessPhone(props)}`,
          x: 159,
          y: 21,
          fontWeight: 'bold',
          fontSize: 7,
          lineHeight: 1.2,
        },
        {
          name: 'Business Fax',
          getText: props => `Fax: ${getBusinessFax(props)}`,
          x: 159,
          y: 24,
          fontWeight: 'bold',
          fontSize: 7,
          lineHeight: 1.2,
        },
      ],
      fields: [
  
        {
          name: 'Tax ID',
          type: 'text',
          getValue: getInquiringProviderTaxID,
          x: 61,
          y: 50,
          width: 50,
        },
        {
          name: 'NPI',
          type: 'text',
          getValue: getBusinessNPI,
          x: 135,
          y: 50,
          width: 50,
        },
        {
          name: 'Date',
          type: 'text',
          x: 30,
          y: 59,
          width: 35,
          normalize: normalize.date,
        },
        {
          name: 'Name',
          type: 'text',
          x: 20,
          y: 100,
          width: 65,
          getValue: getAccountName,
        },
        {
          name: 'Patient Name',
          type: 'text',
          getValue: getPatientName,
          x: 47,
          y: 114,
          width: 120,
        },
        {
          name: 'Patient DOB',
          type: 'text',
          getValue: getPatientFullDob,
          x: 47,
          y: 123,
          width: 120,
          normalize: normalize.date,
        },
        {
          name: 'Member ID',
          type: 'text',
          getValue: getInsuranceID,
          x: 47,
          y: 133,
          width: 120,
        },
        {
          name: 'Ref Doctor',
          type: 'text',
          getValue: (props) => `${getPrescriberName(props)} NPI: ${getPrescriberNPI(props)}`,
          x: 47,
          y: 141,
          width: 120,
        },
        {
          name: 'Diagnosis',
          type: 'text',
          getValue: getDiagnosisCode,
          x: 47,
          y: 151,
          width: 120,
        },
        ...[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].reduce((accumulator, currentValue) => {
          const y = 166.5 + (currentValue * 5.75);
          return [
            ...accumulator,
            {
              name: `HCPCS ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineHCPCSCode({ ...props, index: currentValue }),
              x: 20,
              y,
              width: 24,
              normalize: normalize.hcpcCode,
            },
            {
              name: `Description ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineDescription({ ...props, index: currentValue }),
              x: 49,
              y,
              width: 73,
            },
            {
              name: `Qty ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineUnits({ ...props, index: currentValue }),
              x: 126,
              y,
              width: 21,
              normalize: normalize.number,
            },

            {
              name: `Charge ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineCharge({ ...props, index: currentValue }),
              x: 149,
              y,
              width: 18,
              normalize: normalize.price,
              chargeField: true,
            },
            
            {
              name: `Total Cost ${currentValue}`,
              type: 'text',
              getValue: props => getOrderLineTotalCharge({ ...props, index: currentValue }),
              x: 170,
              y,
              width: 23.5,
              normalize: normalize.price,
              chargeField: true,
            },
          ];
        }, []),
      ],
    },
  ],
};

export default DeliveryTicketDeliveryInstructionsAndReceipt;



// WEBPACK FOOTER //
// ./src/config/documents/Prior-Authorization-Template-Alba-Authorization-Request.js